import React from 'react';

function About(props){
    return(
        <div className="App">
            <h1 className="marginTop">About:</h1>
            <p className="about marginTop2">This is a Todo app, where a user can add and delete his/her todo items and also manage them by marking the items as done.</p>
        </div>
    )
}


export default About;